import React, { useEffect, useState } from "react";
import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import Button from "../../Common/FormElements/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { emailExists } from "../../LoginForm/emailValidation";
import { prospectUserForm } from "./data";
import { useTranslation } from "react-i18next";
import ProspectInformationForm from "./ProspectInformationForm";
import {
  createProspectUser,
  getProspectUser,
  updateProspectUser,
} from "../../../REDUX/actions/prospects";
import { closeRightModal } from "../../../REDUX/actions/rightModal";
import { isDefined } from "../../../Utils";

function ProspectUserForm({ id, prospectId }) {
  const { t } = useTranslation("common");
  console.log(prospectId);

  const dispatch = useDispatch();
  const {
    prospectUser,
    prospectUserLoading,
    createProspectUserLoading,
    updateProspectUserLoading,
  } = useSelector((state) => state.prospectsReducer);

  const [activeTab, setActiveTab] = useState("Informations");
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [customErrors, setCustomErrors] = useState({});

  const handleClick = async () => {
    try {
      const currEmail = prospectUser?.email;
      if (!id || currEmail !== formData?.email) {
        const exists = await emailExists(formData?.email);
        if (exists) {
          setCustomErrors({ ...customErrors, email: "exist" });
          return;
        }
      }
      const phoneNumberPattern = /^(\+|\d{1,4})\s?(\d\s?){5,}$/;
      if (!formData.phoneNumber?.match(phoneNumberPattern)) {
        setCustomErrors({
          ...customErrors,
          phoneNumber: "phoneNumberError",
        });
        return;
      }
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!formData?.email.match(emailPattern)) {
        setCustomErrors({
          ...customErrors,
          email: "emailError",
        });
        return;
      }

      if (prospectUser) {
        dispatch(
          updateProspectUser(prospectUser.id, formData, t, () =>
            dispatch(closeRightModal())
          )
        );
      } else {
        dispatch(
          createProspectUser(prospectId, formData, t, () =>
            dispatch(closeRightModal())
          )
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "CLEAR_PROSPECT_USER" });
    if (isDefined(id)) {
      dispatch(getProspectUser(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    setFormData((currState) => {
      const updatedFormData = { ...currState };

      prospectUserForm.forEach(({ name, type }) => {
        if (type === "select") {
          updatedFormData[name] = {
            name: prospectUser?.[name],
            code: prospectUser?.[name],
          };
        } else {
          updatedFormData[name] = prospectUser?.[name];
        }
      });
      return updatedFormData;
    });
  }, [prospectUser]);

  return (
    <div className="newIntermediary d-flex flex-column justify-content-between h100">
      <div>
        <h2 className="sBold f25 quickSand text-blue px-5 mb-5">
          {id ? t("Edit profile") : t("Add a new profile")}
        </h2>
        <TabsNavbar
          tabs={["Informations"]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className="gap-5"
        />
        <ProspectInformationForm
          isUpdating={!!prospectUser}
          formData={formData}
          setFormData={setFormData}
          setDisabled={setDisabled}
          customErrors={customErrors}
          setCustomErrors={setCustomErrors}
        />
      </div>
      <div className="buttonsContainer d-flex justify-content-center mt-5">
        <Button variant="outline" className="me-4">
          {t("Cancel")}
        </Button>
        <Button
          className="me-4"
          loading={
            createProspectUserLoading ||
            updateProspectUserLoading ||
            prospectUserLoading
          }
          disabled={disabled}
          onClick={
            createProspectUserLoading || updateProspectUserLoading
              ? undefined
              : handleClick
          }
        >
          {t("Save")}
        </Button>
        {/* <Button variant="lightBlue">Envoyer les accés</Button> */}
      </div>
    </div>
  );
}

export default ProspectUserForm;
